
import Vue from 'vue'
// PC端组件
import { Tag, Input, Button, Checkbox, Select, Row, Col, Modal, Icon, Spin, Tooltip, Alert, Divider, Skeleton, message, notification } from 'ant-design-vue'

Vue.use(Input)
Vue.use(Tag)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Icon)
Vue.use(Spin)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Divider)
Vue.use(Skeleton)
Vue.use(notification)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$destroyAll = Modal.destroyAll
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning
